import "./AssetTimelineHeader.css";

import {
  ApplicationIcon,
  Button,
  Icon,
  Typography,
} from "@saviynt/design-system";
import { getRouteApi, useRouter } from "@tanstack/react-router";
import { useIntl } from "react-intl";
import { getApplicationSourceIcon } from "../../PoliciesSidepanel/PoliciesSidepanel";

const routeApi = getRouteApi("/_policies/access-map/$assetId");

export default function AssetTimelineHeader() {
  const { source = "", name = "", connectionName = "" } = routeApi.useSearch();
  const router = useRouter();
  const intl = useIntl();

  const navigateBack = () => {
    router.history.back();
  };

  return (
    <div className="NHI-asset-header" role="region">
      <div className="NHI-asset-header-wrapper">
        <Button
          onClick={navigateBack}
          type="button"
          kind="ghost"
          size="medium"
          leftIcon={<Icon kind="ChevronLeft" />}
          ariaLabel={intl.formatMessage({
            defaultMessage: "Go back to Non-Human Identities",
            id: "KzQkXM",
            description: "Go back to Non-Human Identities",
          })}
        />
        <ApplicationIcon
          logo={getApplicationSourceIcon(source)}
          size="large"
          dataTestId={`ApplicationIcon-${source}`}
        />

        <div className="NHI-asset-header-title">
          <Typography kind="h1" color="--color-foreground-neutral-bold">
            {name}
          </Typography>
          <Typography kind="body1" color="--color-foreground-neutral-subtle">
            {connectionName}
          </Typography>
        </div>
      </div>
    </div>
  );
}
